import { render, staticRenderFns } from "./LocalCamera.vue?vue&type=template&id=e4af3916&scoped=true&"
import script from "./LocalCamera.vue?vue&type=script&lang=js&"
export * from "./LocalCamera.vue?vue&type=script&lang=js&"
import style0 from "./LocalCamera.vue?vue&type=style&index=0&id=e4af3916&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4af3916",
  null
  
)

export default component.exports